import { NS } from './namespaces';
import { Unit, getTypeMap } from "./units";

export default class Units {
    public static convertToSvgUnitsDpiAware(value: string | number, unit: Unit = null): number {
        let r = Number.parseFloat(value.toString());
        if (isNaN(r)) {
            return r;
        }

        if (!unit) {
            unit = Units.getUnitString(value.toString());
        }

        if (unit) {
            unit = unit.toLowerCase() as Unit;
            const conv = getTypeMap()[unit];

            if (conv) {
                r *= conv;
            } else {
                console.warn(`Could not convert ${value} to SVG units - ${unit} is not recognized!`)
            }

            r *= 72.0 / Units.getDocumentDPI();
        }

        return r;
    }

    public static convertSvgUnitsToDpiAware(value: string | number, unit: Unit) {
        if (typeof value != "number") {
            value = parseFloat(value);
        }

        unit = unit.toLowerCase() as Unit;
        const conv = getTypeMap()[unit];

        if (!conv) {
            console.warn(`Could not convert ${value} from SVG units - ${unit} is not recognized!`);
            return value;
        }

        return value / conv * (Units.getDocumentDPI() / 72.0);
    }

    public static getUnitString(value: string): Unit {
        if (isNaN(value as any) && value.length > 2) {
            return value.substring(value.length - 2) as Unit;
        }

        return "px";
    }

    public static getDocumentDPI(): number {
        const dpi = document.getElementById("svgcontent")?.getAttribute("zaa:dpi");
        if (dpi) {
            return parseFloat(dpi);
        }

        return 72.0;
    }
}
